import Box from '@mui/material/Box';
import { Button } from '../../../../shared/components/button/Button';
import usePedidoBuscar from '../../../../hooks/usePedidoBuscar';
import ComponentTable from '../../../Components/Table/Index';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import * as Icon from '@mui/icons-material';
import { Loader } from '../../../../shared/components/Loader';
import LoadingButton from '@mui/lab/LoadingButton';
import FormBuilder from '../../../../shared/components/FormBuilder';
import { ModalDevolucao } from '../Devolucao/ModalDevolucao';
import { ModalRelatorio } from '../../../../shared/components/ModalRelatorio';

/* [01/10] Um estilo so para os quatro botoes de relatorio (eram quatro copias).
 * whiteSpace nowrap: "Pecas Vendidas" quebrava em duas linhas. fontSize 14 e sem
 * marginLeft: em tela menor os cinco botoes nao cabiam e se sobrepunham - o espaco entre
 * eles agora vem do gap do HeaderComponent, que tambem os deixa descer de linha. */
const estiloBotaoRelatorio = {
  color: '#fff',
  backgroundColor: '#1976d2',
  '&:hover': { backgroundColor: '#1769bb' },
  textTransform: 'none',
  fontSize: '14px',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  '&&.Mui-disabled': {
    color: '#ddd',
  },
} as const;

export const PedidoPesquisar = () => {
  const {
    handleNavigation,
    handleEditItem,
    loading,
    tableColumns,
    pedidosLista,
    loadingRelatorio,
    downloadRelatorio,
    abrirRelatorioLocacao,
    gerarRelatorioLocacao,
    modalLocacaoAberto,
    fecharModalLocacao,
    loadingLocacao,
    abrirRelatorioServicos,
    gerarRelatorioServicos,
    modalServicosAberto,
    fecharModalServicos,
    loadingServicos,
    abrirRelatorioPecas,
    gerarRelatorioPecas,
    modalPecasAberto,
    fecharModalPecas,
    loadingPecas,
    periodoSugerido,
    formRef,
    onSubmit,
    initialValues,
    fields,
    devolucaoVendaId,
    setDevolucaoVendaId,
    handleList,
  } = usePedidoBuscar();

  return (
    <Box>
      <HeaderComponent
        text={'Vendas'}
        ButtonRight={
          <>
            <Button
              className={'whitespace-nowrap'}
              variant='success'
              onClick={handleNavigation}
              iconStart={<Icon.Add />}
              title={'Incluir'}
            />
            <LoadingButton
              loading={loadingRelatorio}
              loadingPosition="start"
              startIcon={<Icon.FileDownload />}
              variant="outlined"
              onClick={downloadRelatorio}
              sx={estiloBotaoRelatorio}
            >
              <p>Relatório</p>
            </LoadingButton>
            {/* [29/09] Relatório de Locação. Botão próprio, e não uma opção escondida
                dentro do "Relatório" que já existia: aquele é o de Vendas, e trocá-lo por
                um menu mudaria um caminho que já está no dedo de quem usa. */}
            <LoadingButton
              loading={loadingLocacao}
              loadingPosition="start"
              startIcon={<Icon.FileDownload />}
              variant="outlined"
              onClick={abrirRelatorioLocacao}
              title="Recibos de locação vencidos no período"
              sx={estiloBotaoRelatorio}
            >
              <p>Locação</p>
            </LoadingButton>
            <LoadingButton
              loading={loadingServicos}
              loadingPosition="start"
              startIcon={<Icon.FileDownload />}
              variant="outlined"
              onClick={abrirRelatorioServicos}
              title="Ordens de serviço emitidas no período"
              sx={estiloBotaoRelatorio}
            >
              <p>Serviços</p>
            </LoadingButton>
            <LoadingButton
              loading={loadingPecas}
              loadingPosition="start"
              startIcon={<Icon.FileDownload />}
              variant="outlined"
              onClick={abrirRelatorioPecas}
              title="Peças vendidas por pedido faturado vindo de Ordem de Serviço"
              sx={estiloBotaoRelatorio}
            >
              <p>Peças Vendidas</p>
            </LoadingButton>
          </>
        }
      />
      {/* Só período: o Relatório de Locação não tem filtro de setor. O mesmo modal do
          Faturamento, sem a propriedade `setores`, e o combo nem aparece. */}
      <ModalRelatorio
        open={modalLocacaoAberto}
        onClose={fecharModalLocacao}
        titulo={'Relatório de Locação'}
        dataInicioInicial={periodoSugerido?.inicio}
        dataFimInicial={periodoSugerido?.fim}
        gerando={loadingLocacao}
        onGerar={gerarRelatorioLocacao}
      />
      {/* Também só período - o mesmo modal, sem `setores`. */}
      <ModalRelatorio
        open={modalServicosAberto}
        onClose={fecharModalServicos}
        titulo={'Relatório de Serviços'}
        dataInicioInicial={periodoSugerido?.inicio}
        dataFimInicial={periodoSugerido?.fim}
        gerando={loadingServicos}
        onGerar={gerarRelatorioServicos}
      />
      {/* Também só período. */}
      <ModalRelatorio
        open={modalPecasAberto}
        onClose={fecharModalPecas}
        titulo={'Relatório de Peças Vendidas'}
        dataInicioInicial={periodoSugerido?.inicio}
        dataFimInicial={periodoSugerido?.fim}
        gerando={loadingPecas}
        onGerar={gerarRelatorioPecas}
      />
      <Loader loading={loading}>
        <FormBuilder innerRef={formRef} fields={fields} onSubmit={onSubmit} initialValues={initialValues} gap='gap-3' />
        <ComponentTable columns={tableColumns} rows={pedidosLista} onRowDoubleClick={(row) => {
          handleEditItem(row, true, row.vnd_id);
        }} />
      </Loader>

      {/* A devolucao comeca na propria tela da venda, pelo menu da linha. O modal se vira
          sozinho: pergunta a API se o pedido pode ser devolvido e, quando nao pode, mostra
          o motivo em vez de simplesmente nao abrir. */}
      <ModalDevolucao
        aberto={devolucaoVendaId !== null}
        vendaId={devolucaoVendaId}
        aoFechar={(houveMudanca: boolean) => {
          setDevolucaoVendaId(null);
          // So recarrega a grade se algo mudou de verdade - fechar sem confirmar nao
          // precisa custar uma consulta.
          if (houveMudanca) handleList();
        }}
      />
    </Box>
  );
};
